export enum BugStatus {
  New = 'new',
  Fixed = 'fixed',
  NotABug = 'notabug',
  Duplicated = 'duplicated',
  Deferred = 'deferred',
}
